import { useEffect, useRef } from 'react';

import BottomSheet, {
  type BottomSheetRef,
} from '@cartwhl/ui/layout/BottomSheet';
import Panel from '@cartwhl/ui/layout/Panel';

import type { CanvasLayoutRegisteredSidePanel } from './canvasLayoutContext';

interface CanvasLayoutMobilePanelProps {
  sidePanel: CanvasLayoutRegisteredSidePanel | null;
}

export default function CanvasLayoutMobilePanel({
  sidePanel,
}: CanvasLayoutMobilePanelProps) {
  const sheetRef = useRef<BottomSheetRef>(null);

  useEffect(() => {
    if (sidePanel !== null) {
      sheetRef.current?.open();
      return;
    }

    sheetRef.current?.close();
  }, [sidePanel]);

  return (
    <BottomSheet
      ref={sheetRef}
      className="z-30 overflow-x-hidden"
      detents={sidePanel?.mobileDetents}
      grabberVisible
      onClose={sidePanel?.closePanel}
    >
      {sidePanel !== null && (
        <Panel
          key={sidePanel.id}
          title={sidePanel.title}
          closePanel={sidePanel.closePanel}
          loading={sidePanel.loading}
          statusText={sidePanel.statusText}
          additionalButtons={sidePanel.additionalButtons}
          className={sidePanel.className}
        >
          {sidePanel.children}
        </Panel>
      )}
    </BottomSheet>
  );
}
